import useTranslate from '@core/hooks/useTranslate';
import { ProductContext } from '@root/modules/Sellers/provider/ProductProvider';
import BreadcrumbList from '@root/modules/Sellers/Stock/components/Breadcrumb';
import inquiryService from '@root/modules/Warehouse/Inquiry/service/inquiry';
import { Card, Spin } from 'antd';
import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import DetailDescript from '../components/DetailDescript';

interface Param {
  key: string;
}
const breadcrumbList = [
  {
    tittle: 'Inquiry',
    url: '/admin/inquiry'
  },
  {
    tittle: 'Detailed Inquiry',
    url: ''
  }
];

const InquiryDetailPage = ({ listInquiry }: any) => {
  const [proDeWare, setProDeWare] = useContext<any>(ProductContext);

  const [t] = useTranslate();
  const [proWareItem, setWareItem] = useState([] as any);

  const { id }: any = useParams();
  const [loading, setLoading] = useState<boolean>(false);

  const getDetail = async () => {
    setLoading(true);
    const detailInWare = await inquiryService.getDetailInquiry(id);

    setProDeWare(detailInWare.data);
    const listDe: any[] = [];
    const arr: any[] = detailInWare?.data?.products;
    arr?.forEach((item: any) => {
      listDe.push({
        productName: item.productName,
        width: item.width,
        length: item.length,
        height: item.height,
        demensionUnit: item.demensionUnit,
        weight: item.weight,
        weightUnit: item.weightUnit,
        estimateQuantity: item.estimateQuantity,
        averageMonthSale: item.averageMonthSale,
        sku: item.sku,
        eanUpc: item.eanUpc,
        asin: item.asin,
        packedMethod: item.packedMethod,
        storageMethod: item.storageMethod,
        dangerousGoods: item.dangerousGoods,
        lotProduct: item.lotProduct,
        image: item?.image?.url
      });
    });
    setWareItem(listDe);
    setProDeWare(detailInWare.data);
    setLoading(false);
  };

  useEffect(() => {
    getDetail();
  }, []);
  const valueMethod = proDeWare?.shipmentMethod;
  const [method, setMethod] = useState(valueMethod);

  const Breadcrumb = [
    {
      tittle: 'Inquiry',
      url: '/admin/inquiry'
    },
    {
      tittle: 'Detailed Inquiry',
      url: ''
    }
  ];

  let statusFix =
    proDeWare?.status === 'SellerApproved'
      ? 'Approval'
      : proDeWare?.status === 'WarehouseApproved'
      ? 'Approval'
      : proDeWare?.status === 'Rejected'
      ? 'Reject'
      : proDeWare?.status === 'New'
      ? 'New'
      : '';
  return (
    <>
      <BreadcrumbList listBreadcrumb={Breadcrumb} />

      <Spin spinning={loading} className="loading-forgot">
        <div className="admin-container">
          {' '}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              margin: '0px 24px',
              background: 'white',
              padding: '10px'
            }}
          >
            <div style={{ display: 'flex' }}>
              <p
                style={{
                  marginBottom: '0px',
                  fontWeight: 'bold',
                  fontSize: '15px'
                }}
              >
                {proDeWare?.sellerName}
              </p>
              <p
                style={{
                  marginBottom: '0px',
                  marginLeft: '10px',
                  color: '#747274'
                }}
              >
                {proDeWare?.sellerEmail}
              </p>{' '}
            </div>

            <p
              style={{
                marginBottom: '0px',
                fontWeight: 'bold',
                fontSize: '15px',
                width: '150px',
                marginLeft: 'auto',
                display: 'block',
                borderRadius: '20px',
                padding: '6px 0px',
                background: '#2B2C51',
                color: 'white',
                textAlign: 'center'
              }}
            >
              {statusFix}
            </p>
            {/* <p
              style={{
                marginBottom: '0px',
                marginLeft: '10px',
                color: '#747274'
              }}
            ></p> */}
          </div>
          <Card
            bordered={false}
            className="admin-card"
            style={{
              minHeight: '100vh',
              background: 'none'
            }}
          >
            <div
              className=""
              style={{
                minHeight: '100vh',
                backgroundColor: 'white',
                padding: '30px 10px',
                borderRadius: '6px'
              }}
            >
              <DetailDescript
                getDetail={getDetail}
                proWareItem={proWareItem}
                proDeWare={proDeWare}
                side='WAREHOUSE'
                screenName='WAREHOUSE_INQUIRY_DETAIL'
                disabledComment={false}
              />
            </div>
          </Card>
        </div>
      </Spin>
    </>
  );
};

export default InquiryDetailPage;
